import { Section } from "./PortalPage";
import { downloadAuthFile } from "../../lib/fileOpen";
import { fmtDate } from "./portalUtils";
import { ShieldCheck, DownloadSimple } from "@phosphor-icons/react";

/** Client portal: issued Risk Assessments & Method Statements on a job, each with a branded PDF download. */
export function ClientRamsSection({ rams, jobRef }) {
  if (!rams?.length) return null;
  return (
    <Section title={<span className="flex items-center gap-1.5"><ShieldCheck size={14} /> Risk Assessments &amp; Method Statements (RAMS)</span>} testid="client-job-rams">
      <p className="text-xs text-muted-foreground mb-3">Issued by our team before work starts. Every engineer on this job reads and signs the RAMS on site.</p>
      <div className="space-y-2">
        {rams.map((r) => (
          <button key={r.id} type="button" onClick={() => downloadAuthFile(`/api/hs/rams/${r.id}/pdf`, `${jobRef || "job"}_${r.number}_v${r.version}.pdf`)} className="w-full flex items-center gap-3 border border-border rounded-md p-3 hover:bg-muted/40 text-left" data-testid={`client-rams-${r.id}`}>
            <div className="h-9 w-9 rounded-md bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300 flex items-center justify-center shrink-0"><ShieldCheck size={18} /></div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate"><span className="font-mono text-xs text-muted-foreground mr-2">{r.number}</span>{r.title}</p>
              <p className="text-xs text-muted-foreground">v{r.version} · issued {fmtDate(r.issued_at)} · {r.hazards} hazard{r.hazards === 1 ? "" : "s"} assessed · {r.signed}/{r.operatives} engineer{r.operatives === 1 ? "" : "s"} signed{r.review_date ? ` · review ${fmtDate(r.review_date)}` : ""}</p>
            </div>
            <span className="inline-flex items-center gap-1 text-xs text-primary shrink-0" data-testid={`client-rams-pdf-${r.id}`}><DownloadSimple size={14} /> PDF</span>
          </button>
        ))}
      </div>
    </Section>
  );
}
